import { __read } from "tslib";
import { useEffect, useState } from 'react';
import { BreakpointNames } from '../theme/Breakpoint/Breakpoint';
import { getMaxWidth, getMinWidth } from '../theme/MediaQuery/utils';
import { isBrowser } from '../utils/browser';
import { getBreakpointByWidth } from '../theme/Breakpoint/BreakpointUtils';
var settersFromUseState = [];
if (isBrowser()) {
    setupMediaQueryListeners();
}
/* Could pass the breakpoint instead of getting the value from window size,
 * but initially also the getBreakpointByWidth value is used in useState.
 * So this is more in line with that.
 */
function matchMediaCallback(event) {
    if (event.matches) {
        var bp_1 = getBreakpointByWidth(window.innerWidth);
        settersFromUseState.forEach(function (setBreakpoint) {
            // no need to check for same value as previous one,
            // because useState setters already have this built-in
            // (1 more rerender without children to make sure it stays the same)
            setBreakpoint(bp_1);
        });
    }
}
function setupMediaQueryListeners() {
    for (var i = 0; i < BreakpointNames.length; i++) {
        var currentBreakpointName = BreakpointNames[i];
        var nextBreakpointName = BreakpointNames[i + 1];
        var query = "" + getMinWidth(currentBreakpointName);
        if (nextBreakpointName !== undefined) {
            query += " and " + getMaxWidth(nextBreakpointName);
        }
        var mql = window.matchMedia(query);
        if ('addEventListener' in mql) {
            mql.addEventListener('change', matchMediaCallback);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore (deprecated, but we still need to support ie/older safari)
            mql.addListener(matchMediaCallback);
        }
    }
}
/* To get the breakpoint in JS runtime.
 * (will give null for SRR)
 * There are alternatives for using this for common cases, see story links. */
var useBreakpoint = function () {
    var _a = __read(useState(isBrowser() ? getBreakpointByWidth(window.innerWidth) : null), 2), breakpoint = _a[0], setBreakpoint = _a[1];
    useEffect(function () {
        settersFromUseState.push(setBreakpoint);
        return function () {
            settersFromUseState.splice(settersFromUseState.indexOf(setBreakpoint), 1);
        };
    }, []);
    return breakpoint;
};
/* To get the typography breakpoint in JS runtime. Should have no use cases.
 * (will give null for SRR)
 * See story for alternatives */
var useTypographyBreakpoint = function () {
    var breakpoint = useBreakpoint();
    switch (breakpoint) {
        case 'mobile':
        case 'mobileLandscape':
            return 'mobile';
        case 'tablet':
        case 'lap':
            return 'tablet';
        case 'desktop':
        case 'wide':
            return 'desktop';
        default:
            return null;
    }
};
export { useBreakpoint, useTypographyBreakpoint };
//# sourceMappingURL=useBreakpoint.js.map